import BaseApi from "@/core/HttpResources/BaseApi";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import UserResearchCenter from '@/models/security/userResearchCenter.Model';

export default class UserResearchCenterService {
    baseApiPublish = new BaseApi("UserResearchCenter");

    async save(userResearchCenter: UserResearchCenter): Promise<Array<any>> {
        var baseApi = new BaseApi("UserResearchCenter");
        return new Promise<any>((resolve, reject) =>
            baseApi.request("POST", String(), userResearchCenter, {}, response => resolve(response.data), reject,() => {})
        );
    }
    
    async getResearchCenterAdmin(id: string|number): Promise<any> {
        return new Promise<any>((resolve, reject) =>
          this.baseApiPublish.request(
            "GET",
            "GetResearchCenterAdmin/" + id,
            null,
            {},
            response => resolve(response.data),
            reject,
            () => {}
          )
        );
      }
        
    async getUserResearchCenterColaborator(id: string|number): Promise<any> {
      return new Promise<any>((resolve, reject) =>
        this.baseApiPublish.request(
          "GET",
          "GetUserResearchCenterColaborator/" + id,
          null,
          {},
          response => resolve(response.data),
          reject,
          () => {}
        )
      );
    }

}